import React from 'react';
import PropTypes from 'prop-types';
import { createModal } from 'react-modal-promise';
import '../../ReactModal/reactModal.scss';

const prodigyModal = ({ program, close }) => (
  <div className="p-modal-container program-details-modal-container">
    <div className="p-modal program-details-modal">
      <i
        onClick={() => close(false)}
        className="modal-close close icon"
        alt="close"
      />
      <div className="p-modal-body program-details-modal-body">
        {program.dealerProgramText}
      </div>
      <div className="p-modal-actions">
        <button
          className="btn btn-primary btn-large btn-large-default"
          onClick={() => close()}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

prodigyModal.propTypes = {
  close: PropTypes.func,
  program: PropTypes.object,
};

const ProgramDetailsModal = createModal(prodigyModal);

export default ProgramDetailsModal;
